import React from 'react'

export default function MyMapLayerButton(props) {

    function getContainerStyle() {
        //優先順：モバイルモード>検索結果一覧の有無>検索パネルの開閉
        var isMargin =  false;
        if(props.isMobileMode){
            isMargin = false;
        }else{
            if(props.isShowSearchResultPanel){
                if(props.searchPanelVisible){
                    isMargin = true;
                }else{
                    isMargin = false;
                }
            }else{
                isMargin = false;
            }
        }
        return {
            margin: "10px 10px 30px "+ (10 + (isMargin ? (props.width > 530 ? 400 : props.width) : 0)) +"px"
        };
    }

    return (
    <div className="mapLayer" style={getContainerStyle()}>
        <div>
            <button
                type="button"
                className="mapLayerButton"
                onClick={props.onLayerButtonClick}>
                    <img src={"/Icons/Layers/layer.png"} style={{width:"100%",height:"100%"}} alt="" />
                    <label>レイヤー</label>
            </button>
        </div>
    </div>
    );

}
